import {
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
	useColorModeValue,
} from '@chakra-ui/react';
import { MdCheckCircleOutline, MdOutlineHighlightOff } from 'react-icons/md';
import { RiErrorWarningLine } from 'react-icons/ri';

export default function ResultMessage({
	isOpen,
	onClose,
	message,
	firstButton,
	secondButton,
}) {
	const hasCustomButtons = firstButton || secondButton;
	const cardBg = useColorModeValue('gray.100', 'gray.700');
	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered>
			<ModalOverlay />
			<ModalContent bg={cardBg} maxWidth='400px'>
				<ModalHeader
					display='flex'
					alignItems='center'
					gap='10px'
					pt='50px'
					textAlign='left'
				>
					{message.state === 'warning' && (
						<RiErrorWarningLine color='#C27400' size='25px' />
					)}
					{message.state === 'error' && (
						<MdOutlineHighlightOff color='#E31A1A' size='25px' />
					)}
					{message.state === 'success' && (
						<MdCheckCircleOutline color='#5CB85C' size='25px' />
					)}
					{message.title}
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody pb={6}>
					<Text>{message.subtitle}</Text>
				</ModalBody>
				<ModalFooter flexWrap='wrap' gap={{ base: '20px', md: '10px' }} mb={8}>
					{firstButton && (
						<Button
							w={{ base: '100%', md: 'fit-content' }}
							onClick={firstButton.onClick}
							variant='brand'
						>
							{firstButton.label}
						</Button>
					)}
					{secondButton && (
						<Button
							w={{ base: '100%', md: 'fit-content' }}
							variant='outline'
							onClick={secondButton.onClick}
						>
							{secondButton.label}
						</Button>
					)}
					{!hasCustomButtons && <Button onClick={onClose}>Cerrar</Button>}
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
}
